import classNames from 'classnames';

import classes from './ErrorMessage.module.css';

const ErrorMessage = ({ children, className=null }) => {

    return (
        <span className={classNames(classes.root, className)}>
            { children }
        </span>
    );
}

export default ErrorMessage;